module.exports = __webpack_public_path__ + "97470e69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/up-arrow-angle.svg
// module id = 1561
// module chunks = 0 1 15 17 20 22 33